import { styled } from 'styled-components';
import { ThemeProps } from '../../themes/theme';

export const Slider = styled.span`
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${(props) => props.theme.inputBorderColor};
    transition: 0.2s;

    border-radius: 24px;

    &:before {
        position: absolute;
        content: '';
        height: 20px;
        width: 20px;
        left: 2px;
        bottom: 2px;
        background-color: white;
        transition: 0.2s;
        border-radius: 50%;
    }
`;

export const Label = styled.label<ThemeProps>`
    position: relative;
    display: inline-block;
    min-width: 40px;
    height: 24px;
`;

export const Input = styled.input`
    opacity: 0;
    width: 0;
    height: 0;

    &:checked + ${Slider} {
        background-color: ${(props) => props.theme.inputActiveColor};
    }

    &:disabled + ${Slider} {
        cursor: not-allowed;
        opacity: 0.5;
    }

    &:focus + ${Slider} {
        box-shadow: 0 0 1px ${(props) => props.theme.inputActiveColor};
    }

    &:checked + ${Slider}:before {
        transform: translateX(16px);
    }
`;

// The slider <label> above wraps the input but holds no text, so it can't name
// it. The visible text sits outside the slider (Composite orders the two, and
// `reverse` swaps them), so it needs its own <label for>. Styled to match what
// <Text> rendered here before: Body's colour and wrapping, and `p { margin: 0 }`
// from GlobalStyle meant the <p> carried no margin either.
export const LabelText = styled.label<ThemeProps>`
    color: ${(props) => props.theme.textColor};
    overflow-wrap: break-word;
    cursor: pointer;
`;
